import { DateTime, Duration, type DurationLikeObject } from 'luxon'

/**
 * Returns a human readable display string for a given duration in seconds.
 * @param seconds duration in seconds
 * @param unitDisplay optional display style for units ('short' | 'long') default is 'long'
 * @returns human readable display string
 */
export function getNiceDuration(seconds: number, unitDisplay: 'short' | 'long' = 'long'): string {
  const timeObj: DurationLikeObject = {
    minutes: Math.round(seconds / 60),
  }
  if (seconds >= 3600) {
    timeObj.hours = 0
  }

  return Duration.fromObject(timeObj).normalize().toHuman({ unitDisplay }).replace(',', '')
}

/**
 * Returns a human readable display string for an ISO date/datetime string,
 * e.g. "2026-09-04T00:00:00.000Z" -> "4 Sep 2026". Falls back to the raw
 * string unchanged if it doesn't parse as a valid date, rather than showing
 * Luxon's "Invalid DateTime" - some mock/simulated data (and potentially
 * real API responses) can hand this something that isn't a real ISO string.
 * @param dateString ISO date or datetime string
 * @returns human readable display string
 */
export function getNiceDate(dateString: string): string {
  const parsed = DateTime.fromISO(dateString)
  return parsed.isValid ? parsed.toLocaleString(DateTime.DATE_MED) : dateString
}
